export enum suggestedTopicsTabIds {
  templates,
  pastTopics,
}
